import { render, staticRenderFns } from "./inbound-fax-completed-icon.vue?vue&type=template&id=72f0a786"
import script from "./inbound-fax-completed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-fax-completed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f0a786')) {
      api.createRecord('72f0a786', component.options)
    } else {
      api.reload('72f0a786', component.options)
    }
    module.hot.accept("./inbound-fax-completed-icon.vue?vue&type=template&id=72f0a786", function () {
      api.rerender('72f0a786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/inbound-fax-completed-icon.vue"
export default component.exports